// removed by extract-text-webpack-plugin
module.exports = {"root":"relatedSearches-module_root_344P1","title":"relatedSearches-module_title_1I--y","bold":"relatedSearches-module_bold_17U36","list":"relatedSearches-module_list_VsSmJ","listItem":"relatedSearches-module_listItem_1KfB7","link":"relatedSearches-module_link_3mcSW"};


//////////////////
// WEBPACK FOOTER
// ./client/pages/search/result/relatedSearches.module.css
// module id = 303
// module chunks = 1 2 3